import { ReactNode } from "react";
import { JSX } from "react";

import Typography from "@mui/material/Typography";

export function Title({ text }: { text: ReactNode }): JSX.Element {
  return (
    <Typography
      variant="h1"
      sx={{
        fontWeight: 400,
        textTransform: "none",
        lineHeight: "1.375rem",
        letterSpacing: "0.46px",
        position: "relative",
        pl: ".25rem",
      }}
    >
      {text}
    </Typography>
  );
}
